var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FormText } from '@ally/metronome-ui';
import { useField } from 'formik';
import React, { useEffect, useState } from 'react';
import { mergeRefs, useRegisterError } from '../../utils';
const FormTextInput = React.forwardRef((_a, ref) => {
    var { name, validate, onBlur, inputType, maxLength, minLength, characterCounter } = _a, props = __rest(_a, ["name", "validate", "onBlur", "inputType", "maxLength", "minLength", "characterCounter"]);
    if (ref === void 0) { ref = null; }
    const [field, meta, helpers] = useField(Object.assign(Object.assign({}, props), { name, validate }));
    const { refValue } = useRegisterError(meta.error);
    const combinedRef = refValue ? mergeRefs([refValue, ref]) : ref;
    const [isReadyToBlur, setIsReadyToBlur] = useState({ value: false });
    /**
     * On native blur, the text input's value is being trimmed and set in the
     * Formik state. The onBlur handlers are invoked in an effect so that this
     * update will be finished beforehand.
     */
    const combinedOnBlur = (e) => {
        const { value } = field;
        if (typeof value === 'string') {
            helpers.setValue(value.trim());
        }
        e.persist();
        setIsReadyToBlur({ value: true, e });
    };
    useEffect(() => {
        if (isReadyToBlur.value) {
            const { e } = isReadyToBlur;
            field.onBlur(e);
            if (onBlur) {
                onBlur(e);
            }
            setIsReadyToBlur({ value: false });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isReadyToBlur]);
    const errorMessage = meta.touched ? meta.error : '';
    return (React.createElement(FormText, Object.assign({ variant: "input", errorNotification: {
            message: errorMessage,
        }, ref: combinedRef, id: name }, (inputType === 'number'
        ? { inputType }
        : {
            inputType,
            maxLength,
            minLength,
            characterCounter,
        }), field, props, { value: field.value || '', onBlur: combinedOnBlur })));
});
export default FormTextInput;
//# sourceMappingURL=TextInput.js.map